export const cacheFetch = (request, permanent = false, cachingDuration = 30) => {
    window.fxsCache = window.fxsCache ||
    ({
        promises:{},
        caches:{
            cache: {
                name:'',
                values:{},
                match: function(request) {
                    var r = this.values[request]
                        ? this.values[request].clone() : null
                    return Promise.resolve(r)
                },
                put: function(request, response) {
                    this.values[request] = response
                    return Promise.resolve()
                }
            },
            open: function(n) {
                this.cache.name = n
                return Promise.resolve(this.cache)
            }
        }
    })

    const caches = (!window.caches || !permanent)
        ? window.fxsCache.caches : window.caches

    return caches
        .open('fxs-calendar')
        .then((cache) => {
            return cache
                .match(request)
                .then((cachedResponse) => {
                    if(cachedResponse){
                        const expirationDate = Date.parse(
                            cachedResponse.headers.get('fxs-cache-expires'))
                            if (expirationDate > new Date()) {
                                return cachedResponse
                        }
                    }
                    if(!window.fxsCache.promises[request]){

                        window.fxsCache.promises[request] = fetch(request)
                            .then((response) => {
                                const expires = new Date()
                                expires.setSeconds(
                                    expires.getSeconds() + cachingDuration,
                                )
                                const cachedFields = {
                                    status: response.status,
                                    statusText: response.statusText,
                                    headers: { 'fxs-cache-expires': expires.toUTCString() },
                                }

                                Object.keys(response.headers).forEach((k) => {
                                    cachedFields.headers[k] = response.headers[k]
                                })

                                const respClone = response.clone()
                                return response.blob().then((body) => {
                                    return cache.put(request, new Response(body, cachedFields))
                                        .then(() => {
                                            delete window.fxsCache.promises[request]
                                            const jsonBody = respClone.json()
                                            respClone.json = () => jsonBody
                                            return respClone
                                        })
                                })
                            })
                        }
                    return window.fxsCache.promises[request]
                })
    })
}
